import { Adapter } from './interfaces';

export function factory<I1, O>(a1: Adapter<I1, O>): (i: I1) => O | undefined;

export function factory<I1, I2, O>(
  a1: Adapter<I1, O>,
  a2: Adapter<I2, O>
): (i: I1 | I2) => O | undefined;

export function factory<I1, I2, I3, O>(
  a1: Adapter<I1, O>,
  a2: Adapter<I2, O>,
  a3: Adapter<I3, O>
): (i: I1 | I2 | I3) => O | undefined;

export function factory<I1, I2, I3, I4, O>(
  a1: Adapter<I1, O>,
  a2: Adapter<I2, O>,
  a3: Adapter<I3, O>,
  a4: Adapter<I4, O>
): (i: I1 | I2 | I3 | I4) => O | undefined;

export function factory<I1, I2, I3, I4, I5, O>(
  a1: Adapter<I1, O>,
  a2: Adapter<I2, O>,
  a3: Adapter<I3, O>,
  a4: Adapter<I4, O>,
  a5: Adapter<I5, O>
): (i: I1 | I2 | I3 | I4 | I5) => O | undefined;

export function factory<I, O>(
  ...adapters: Adapter<I, O>[]
): (i: I) => O | undefined {
  return adapters.reduce(
    (acc, { isMatch, adapt }) =>
      (i: I) =>
        isMatch(i) ? adapt(i) : acc(i),
    (_: I): O | undefined => undefined
  );
}
